import './AnswerKeyMoveIndicator.scss';
import DropdownInput from '../../../selector/DropdownInput';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  dropdownValues: [],
  label: '',
  onChange: () => null,
  value: '',
};

function AnswerKeyMoveIndicator(p) {
  const { dropdownValues, label, onChange, value } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='answer-key-move-indicator' data-test='answer-key-move-indicator'>
      <DropdownInput
        className='answer-key-move-indicator-dropdown'
        dropdownValues={dropdownValues}
        label={label}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}

export default AnswerKeyMoveIndicator;
